// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"78856957","453":"28242017","454":"e9df5db4","702":"5bd641a0"}[chunkId] + ".chunk.js";
};